import {
    getAllTestPack,
    createTestPack,
    updateTestPack,
    deleteTestPack,
    getTestPack
} from "../../../util/api"
import setLoading from "../../../components/Spinner/action"
import setModal from "../../../components/Modal/action"
import setAlert from "../../../components/Alert/action"

export const getAllPack = ({ currentPage, pageSize, searchString, sortBy, sortOrder }) => async dispatch => {
    dispatch(setLoading(true))

    try {
        const res = await getAllTestPack({ currentPage, pageSize, searchString, sortBy, sortOrder })

        if (!res.data) throw new Error("Error in getting test pack")

        if (Array.isArray(res.data)) throw new Error(res.data.map(item => item.value))

        if (pageSize) {
            dispatch({
                type: "SET_TEST_PACK",
                payload: res.data.data,
                // currentPage: res.data.currentPage,
                totalItems: res.data.totalItems,
                pageCount: res.data.pageCount,
            })
        } else {
            dispatch({
                type: "SET_ALL_TEST_PACK",
                payload: res.data.data
            })
        }
    } catch (err) {
        dispatch(setModal({
            type: "danger",
            message: JSON.stringify(err.response.data)
        }))
    }

    dispatch(setLoading(false))
}

export const changePageSizeTestPack = pageSize => async dispatch => {
    dispatch({
        type: "CHANGE_PAGE_SIZE_TEST_PACK",
        payload: pageSize
    })
}

export const changeCurrentPageTestPack = page => async dispatch => {
    dispatch({
        type: "CHANGE_CURRENT_PAGE_TEST_PACK",
        payload: page
    })
}

export const createPack = (data, cb) => async dispatch => {
    dispatch(setLoading(true))

    try {
        const res = await createTestPack(data)
        if (!res.data) throw new Error("Error in creating test pack")

        if (Array.isArray(res.data)) throw new Error(res.data.map(item => item.value))

        dispatch(setAlert({
            type: "success",
            message: "create_test_pack_success"
        }))
        if (cb) cb()
    } catch (err) {
        dispatch(setModal({
            type: "danger",
            message: JSON.stringify(err.message)
        }))
    }

    dispatch(setLoading(false))
}

export const updatePack = (data, cb) => async dispatch => {
    dispatch(setLoading(true))

    try {
        const res = await updateTestPack(data)
        if (!res.data) throw new Error("Error in updating test pack")

        if (Array.isArray(res.data)) throw new Error(res.data.map(item => item.value))

        dispatch(setAlert({
            type: "success",
            message: "update_test_pack_success"
        }))
        if (cb) cb()
    } catch (err) {
        dispatch(setModal({
            type: "danger",
            message: JSON.stringify(err.message)
        }))
    }

    dispatch(setLoading(false))
}

export const removePack = (id, cb) => async dispatch => {
    dispatch(setLoading(true))

    try {
        const res = await deleteTestPack(id)
        if (res.status !== 200) throw new Error("Error in deleting test pack")

        dispatch(setAlert({
            type: "success",
            message: "delete_test_pack_success"
        }))

        if (cb) cb()
    } catch (err) {
        dispatch(setModal({
            type: "danger",
            message: JSON.stringify(err.message)
        }))
    }

    dispatch(setLoading(false))
}

export const getPack = id => async dispatch => {
    dispatch(setLoading(true))
    let res = null

    try {
        res = await getTestPack(id)
        if (!res.data) throw new Error("Error in creating test pack")

        if (Array.isArray(res.data)) throw new Error(res.data.map(item => item.value))
    } catch (err) {
        dispatch(setModal({
            type: "danger",
            message: JSON.stringify(err.message)
        }))
    }

    dispatch(setLoading(false))
    return res
}